import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://6a5bbe4fba4547faacd1d126623291b9@o488543.ingest.sentry.io/5608351",
    tracesSampleRate: 0.2, // 20% of errors events are sent
    allowUrls: [
        /https?:\/\/((static|www)\.)?meteoblue\.com\/build/,
    ],
    denyUrls: [
        "https://www.google-analytics.com/analytics.js",
    ],
    autoSessionTracking:true,
});
